module.exports = __webpack_public_path__ + "img/app1.d0289dc0.png";